import NormalExportPanel from './NormalExportPanel';
import DeliverPrintExportPanel from './DeliverPrintExportPanel';
import SetPreviewExportPanel from './SetPreviewExportPanel';

export const resolveExportPanelComponent = ({ mode, customPanelComponent }) => {
  const normalized = typeof mode === 'string' ? mode.trim().toLowerCase() : '';

  if (normalized === 'custom' && customPanelComponent) {
    return customPanelComponent;
  }

  if (normalized === 'deliverprint') {
    return DeliverPrintExportPanel;
  }

  if (normalized === 'setpreview') {
    return SetPreviewExportPanel;
  }

  return NormalExportPanel;
};
